import React from "react";
import { Alert } from "react-bootstrap";
import { Container, Paper, Table, TableBody, TableContainer, TableHead, TableRow } from "@mui/material";
import { format } from "date-fns";
import { FormSectionBox } from "../../Pedidos/styles";
import { StyledTableCell } from "../../Pedidos/components/acesso/acessoIndex";
import StatusPedido from "../../../Components/StatusPedido";

function getContratoStatus(c) {
  return c?.statusAtual ?? c?.statusContrato;
}

function getContratoDataAtivacao(c) {
  return c?.dataInicio ?? c?.dataAtivacao;
}

function getContratoDataAtualizacao(c) {
  return c?.dataUltimaAtualizacao ?? c?.dataAtualizacao;
}

function getContratoValor(c) {
  return c?.valorAtual ?? c?.valor;
}

function formatDateOrDash(value) {
  if (!value) return "-";
  try {
    return format(new Date(value), "dd/MM/yyyy");
  } catch {
    return "-";
  }
}

export default function ContratoAtualInfo({ contrato }) {
  if (!contrato || !contrato.id || contrato.id <= 0) return null;

  const status = getContratoStatus(contrato);
  const valor = getContratoValor(contrato);

  return (
    <>
      <br />
      <hr />
      <Alert.Heading style={{ textAlign: "center" }}>Informações do Contrato Atual</Alert.Heading>

      <FormSectionBox>
        <Container sx={{ my: 3 }}>
          <TableContainer component={Paper} sx={{ overflow: "visible" }}>
            <Table>
              <TableHead>
                <TableRow>
                  <StyledTableCell>Tipo de Contrato</StyledTableCell>
                  <StyledTableCell>Valor (R$)</StyledTableCell>
                  <StyledTableCell>Data Ativação</StyledTableCell>
                  <StyledTableCell>Data Atualização</StyledTableCell>
                  <StyledTableCell>Status</StyledTableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                <TableRow>
                  <StyledTableCell>
                    {contrato.tipoContrato === 0
                      ? "Manutenção"
                      : contrato.tipoContrato === 1
                        ? "Locação"
                        : contrato.tipoContrato === 2
                          ? "SaaS"
                          : "-"}
                  </StyledTableCell>
                  <StyledTableCell>
                    {valor !== null && valor !== undefined ? Number(valor).toFixed(2) : "-"}
                  </StyledTableCell>
                  <StyledTableCell>{formatDateOrDash(getContratoDataAtivacao(contrato))}</StyledTableCell>
                  <StyledTableCell>{formatDateOrDash(getContratoDataAtualizacao(contrato))}</StyledTableCell>
                  <StyledTableCell>
                    <StatusPedido status={Number(status)} isPedido isContrato />
                  </StyledTableCell>
                </TableRow>

                {contrato.dataCancelamento && (
                  <TableRow>
                    <StyledTableCell colSpan={5} style={{ color: "tomato", fontWeight: "bold" }}>
                      Contrato Cancelado em: {formatDateOrDash(contrato.dataCancelamento)}
                      {contrato.motivoCancelamento && ` - Motivo: ${contrato.motivoCancelamento}`}
                    </StyledTableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </Container>
      </FormSectionBox>
    </>
  );
}

